import { useState, useEffect } from "react";
import { Newspaper, ExternalLink, RefreshCw } from "lucide-react";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { authFetch } from "../services/authService";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsFeed({ user }) {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    setLoading(true);
    try {
      const response = await authFetch(`${API}/news?limit=30`, { });
      if (response.ok) {
        setNews(await response.json());
      }
    } catch (error) {
      toast.error("Errore nel caricamento delle news");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div data-testid="news-page" className="space-y-6">
      {/* Header */}
      <div className="page-header">
        <div>
          <h1 className="page-title">News Automotive</h1>
          <p className="text-zinc-500 mt-1">Ultime notizie dal mondo auto</p>
        </div>
        <Button onClick={fetchNews} variant="outline" className="border-zinc-700">
          <RefreshCw className="w-4 h-4 mr-2" />
          Aggiorna
        </Button>
      </div>

      {/* News Grid */}
      {news.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {news.map((item, index) => (
            <a
              key={index}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="news-card group"
            >
              <div className="flex items-start justify-between mb-3">
                <span className="news-source">{item.source}</span>
                <ExternalLink className="w-4 h-4 text-zinc-600 group-hover:text-primary transition-colors" />
              </div>
              <h3 className="news-title group-hover:text-primary transition-colors">
                {item.title}
              </h3>
              {item.summary && (
                <p className="news-summary">{item.summary.replace(/<[^>]*>/g, '')}</p>
              )}
              {item.published && (
                <p className="text-xs text-zinc-600 mt-3">{item.published}</p>
              )}
            </a>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <Newspaper className="w-16 h-16 empty-state-icon" />
          <p className="empty-state-title">Nessuna news disponibile</p>
          <p className="empty-state-text">Riprova più tardi</p>
        </div>
      )}
    </div>
  );
}
